import { Routes, Route } from "react-router-dom";
import { AppearanceProvider } from "@/magazzino/lib/appearance";
import Layout from "@/magazzino/pages/Layout";
import Dashboard from "@/magazzino/pages/Dashboard";
import ProductsPage from "@/magazzino/pages/ProductsPage";
import MovementsPage from "@/magazzino/pages/MovementsPage";
import CategoriesPage from "@/magazzino/pages/CategoriesPage";
import SuppliersPage from "@/magazzino/pages/SuppliersPage";
import ReportsPage from "@/magazzino/pages/ReportsPage";
import SettingsPage from "@/magazzino/pages/SettingsPage";

export default function MagazzinoOriginale() {
  return <AppearanceProvider><Routes>
    <Route element={<Layout />}>
      <Route index element={<Dashboard />} />
      <Route path="prodotti" element={<ProductsPage />} />
      <Route path="movimenti" element={<MovementsPage />} />
      <Route path="categorie" element={<CategoriesPage />} />
      <Route path="fornitori" element={<SuppliersPage />} />
      <Route path="report" element={<ReportsPage />} />
      <Route path="impostazioni" element={<SettingsPage />} />
    </Route>
  </Routes></AppearanceProvider>;
}
